module.exports = __webpack_public_path__ + "static/media/logPicTwo.700e25a0.jpeg";